import { LIMITS } from '@konvoi/shared';
import { useState } from 'react';

import { navigate } from '../App.js';
import { api, ApiError, type CreatedTour } from '../lib/api.js';
import { Einladung } from '../lib/einladung.js';

/**
 * Eine Ausfahrt anlegen.
 *
 * Nur für den Organisator und nur mit dem gemeinsamen Passwort — der Beitritt
 * selbst bleibt frei. Danach gibt es drei Wege in die Ausfahrt: den Link, den
 * QR-Code und die sechs Ziffern zum Vorlesen.
 */
export function CreatePage(): React.JSX.Element {
  const [name, setName] = useState('');
  const [passwort, setPasswort] = useState('');
  const [läuft, setLäuft] = useState(false);
  const [fehler, setFehler] = useState<string | null>(null);
  const [angelegt, setAngelegt] = useState<CreatedTour | null>(null);
  async function anlegen(event: React.FormEvent): Promise<void> {
    event.preventDefault();
    setFehler(null);
    setLäuft(true);

    try {
      setAngelegt(await api.createTour(name.trim(), passwort));
    } catch (error) {
      setFehler(
        error instanceof ApiError ? error.message : 'Die Ausfahrt konnte nicht angelegt werden.',
      );
    } finally {
      setLäuft(false);
    }
  }

  if (angelegt !== null) {
    return (
      <div className="seite">
        <h1>{angelegt.tour.name}</h1>
        <p>Die Ausfahrt steht. So kommen die anderen hinein:</p>

        <Einladung joinCode={angelegt.joinCode} url={angelegt.joinUrl} />

        <button
          type="button"
          className="knopf knopf--leise"
          onClick={() => {
            void navigator.clipboard?.writeText(angelegt.joinUrl);
          }}
        >
          Link kopieren
        </button>

        <h2>Selbst mitfahren</h2>
        <button
          type="button"
          className="knopf knopf--wichtig"
          onClick={() => {
            navigate(`/beitreten/${angelegt.joinCode}`);
          }}
        >
          Jetzt beitreten
        </button>
      </div>
    );
  }

  return (
    <form className="seite" onSubmit={(event) => void anlegen(event)}>
      <h1>Neue Ausfahrt</h1>

      {fehler !== null && <p className="hinweis hinweis--alarm">{fehler}</p>}

      <label className="feld">
        <span>Bezeichnung</span>
        <input
          type="text"
          value={name}
          maxLength={LIMITS.tourNameMaxLength}
          required
          autoComplete="off"
          placeholder="Sauerlandrunde"
          onChange={(event) => {
            setName(event.target.value);
          }}
        />
      </label>

      <label className="feld">
        <span>Organisator-Passwort</span>
        <input
          type="password"
          value={passwort}
          required
          autoComplete="current-password"
          onChange={(event) => {
            setPasswort(event.target.value);
          }}
        />
      </label>

      <button type="submit" className="knopf knopf--wichtig" disabled={läuft}>
        {läuft ? 'Einen Augenblick …' : 'Ausfahrt anlegen'}
      </button>

      <button
        type="button"
        className="knopf knopf--leise"
        onClick={() => {
          navigate('/');
        }}
      >
        Zurück
      </button>
    </form>
  );
}
